import { ref, provide, inject, type Ref } from 'vue'

type TableInput = {
  activeInputId: Ref<string | null>
  setActiveInput: (id: string) => void
  clearActiveInput: () => void
  getInputState: (isEdit: boolean) => 'edit' | 'view'
}

const TableInputKey = Symbol('tableInput')

export function provideTableInput() {
  const activeInputId = ref<string | null>(null)

  const setActiveInput = (id: string) => (activeInputId.value = id)

  const clearActiveInput = () => {
    activeInputId.value = null
  }

  const getInputState = (isEdit: boolean) => (isEdit ? 'edit' : 'view')

  const store = {
    activeInputId,
    setActiveInput,
    clearActiveInput,
    getInputState,
  }

  provide<TableInput>(TableInputKey, store)

  return store
}

export function useTableInput() {
  const store = inject<TableInput>(TableInputKey)

  if (!store) {
    throw new Error('useTableInput() is called without provider.')
  }

  return store
}
